import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { AudienceSection } from '../components/AudienceSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { Button } from '../components/ui/Button';
import { Circle } from 'lucide-react';
function Divider() {
  return <div className="relative h-px bg-[rgba(255,255,255,0.06)] w-full max-w-6xl mx-auto" data-id="element-181">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[rgba(255,255,255,0.1)] bg-midnight-900 px-2" data-id="element-182">
        <Circle size={6} fill="currentColor" data-id="element-183" />
      </div>
    </div>;
}
export function SalesPage() {
  return <main className="min-h-screen bg-midnight-900 text-white overflow-x-hidden pb-20 md:pb-0" data-id="element-184">
      <HeroSection data-id="element-185" />
      <Divider data-id="element-186" />
      <ProblemSection data-id="element-187" />
      <Divider data-id="element-188" />
      <AudienceSection data-id="element-189" />
      <Divider data-id="element-190" />
      <SolutionSection data-id="element-191" />
      <Divider data-id="element-192" />
      <OfferSection data-id="element-193" />
      <Divider data-id="element-194" />
      <PricingSection data-id="element-195" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 w-full p-4 bg-midnight-900/80 backdrop-blur-xl border-t border-[rgba(255,255,255,0.08)] z-50 md:hidden" data-id="element-196">
        <Button fullWidth href="https://cuerpoencalma.it.com/cart/47459892756667:1" className="py-3 text-base shadow-lg" data-id="element-197">
          Quiero dormir sin ansiedad
        </Button>
      </div>
    </main>;
}